import React, { useMemo, ReactNode, useCallback } from "react";
import classNames from "classnames/dedupe";

import Select from "../../../ActionsSelectors/Select/Select/Select";
import { QtyButtonContent } from "./QtyButtonContent";
import { TThemeVariant } from "../../../Utility/ThemeProvider";
import { TSelectorOption } from "../../../ActionsSelectors/Select/Select/Select.interface";
import { sizePickerData } from "../../../../mock/filtersMock";
import { SelectorOption } from "../../../ActionsSelectors/Select/SelectorOption/SelectorOption";
import useTheme from "../../../Utility/ThemeProvider/useTheme";

type TShoppingBagItemType = "default" | "mini" | "look";

interface IShoppingBagQuantity {
  type?: TShoppingBagItemType;
  hasDisableQuantity?: boolean;
  readonly?: boolean;
  variant?: TThemeVariant;
  selectedQty: TSelectorOption["id"];
  labels: {
    quantity?: ReactNode;
    selectQuantity?: ReactNode;
  };
  opened?: boolean;
  disableQty?: boolean;
  availableQuantity: TSelectorOption[];
  handleQuantityChange?: (value: TSelectorOption["id"]) => void;
}

const ShoppingBagQuantity = ({
  type = "default",
  hasDisableQuantity = false,
  readonly,
  variant,
  selectedQty,
  labels,
  opened,
  disableQty,
  availableQuantity,
  handleQuantityChange,
}: IShoppingBagQuantity) => {
  const theme = useTheme(variant);
  const quantityButtonContent = useCallback((args: any) => {
    return <QtyButtonContent {...args} classes={{ root: "d-flex" }} />;
  }, []);

  const renderQty = useMemo(() => {
    if (readonly) {
      return (
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        /* @ts-ignore:next-line */
        <QtyButtonContent
          classes={{
            root: classNames("d-flex", {
              "fs-12": type === "mini",
              "text-color-white": theme === "dark",
            }),
          }}
          hasSelectedValue
          selected={{ title: selectedQty }}
          titlePrefix={`${labels.quantity}: `}
          labelKey="title"
        />
      );
    }
    return (
      <Select
        opened={opened}
        theme={theme === "dark" ? "light" : "dark"}
        buttonTheme={theme}
        classes={{ root: "dropdown-quantity" }}
        valueKey="id"
        labelKey="title"
        disabled={disableQty}
        dropdownSize="none"
        titlePrefix={`${labels.quantity}: `}
        placeholder={labels.selectQuantity}
        mobilePlaceholder={sizePickerData.mobileTitle}
        noOptionsPlaceholder={sizePickerData.noItemsText}
        options={availableQuantity}
        value={selectedQty}
        customOptionRender={SelectorOption}
        customButtonContentRender={quantityButtonContent}
        onChange={handleQuantityChange}
      />
    );
  }, [
    readonly,
    handleQuantityChange,
    labels,
    selectedQty,
    availableQuantity,
    disableQty,
    opened,
    theme,
    type,
  ]);

  return (
    <div
      className={classNames("d-flex", {
        "flex-column flex-grow-1 align-items-start align-items-lg-end justify-content-end justify-content-lg-start":
          type !== "mini" && type !== "look",
        "mt-auto": type === "mini",
      })}
    >
      {!hasDisableQuantity && renderQty}
    </div>
  );
};

export default ShoppingBagQuantity;
